export const DEBOUNCE_WAIT_FOR_SEARCH_TYPING = 350;
export const DEBOUNCE_WAIT_FOR_MOUSE_EVENTS = 150;
export const CAROUSEL_DEFAULT_SPEED_MS = 300;
export const UI_DATE_FORMAT = 'MM/DD/YYYY';
export const UI_DATE_FORMAT_RANGE = 'MM/DD/YYYY - MM/DD/YYYY';
export const MAX_FILE_SIZE = 10000000;
export const API_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss[Z]';
export const OFFER_DATE_TIME_FORMAT = 'MM/DD/YYYY @ h:mm A';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_LARGE_TRANSITION_DURATION_MS = 400;
//# sourceMappingURL=statics.js.map